import { useState } from "react";

import SectionList from "../Components/List/SectionList";
import SectionFrom from "../Components/Form/SectionFrom";
import { MdCreateNewFolder } from "react-icons/md";
import { IoIosListBox } from "react-icons/io";

function HomePageSection(data) {
  const [view, setView] = useState(true);

  const [editId, setEditId] = useState(null);

  const viewHadler = (i) => {
    setView(i);
    setEditId(null);
  };

  const handleEdit = (id) => {
    setEditId(id);
    setView(false);
  };

  return (
    <div className="my-5 container-fluid">
      <div className="row">
        <div className="col-sm-6">
          <p className="f-18 text-primary pb-2 border-bottom border-primary">
            Home Page Category
          </p>
        </div>
        <div className="col-sm-6 d-flex justify-content-end">
          <div>
            <button
              onClick={() => viewHadler(true)}
              className="btn btn-info shadow-sm text-white mx-2"
            >
              <IoIosListBox className="fs-5" />
            </button>
            <button
              onClick={() => viewHadler(false)}
              className="btn btn-info shadow-sm text-white mx-2"
            >
              <MdCreateNewFolder className="fs-5" />
            </button>
          </div>
        </div>
      </div>
      {!view && (
        <SectionFrom
          data={data}
          editId={editId}
          onSuccessCreated={viewHadler}
        />
      )}
      {view && <SectionList onEdit={handleEdit} />}
    </div>
  );
}

export default HomePageSection;
